var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEllipse37(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 364,
    height: 369,
    viewBox: "0 0 364 369",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M275.212 369C298 347.5 295.691 351.323 315.604 327.799C335.516 304.276 349.841 276.78 357.513 247.356C365.185 217.932 366.006 187.337 359.917 157.844C353.828 128.352 340.984 100.721 322.34 77.0067C303.697 53.2921 279.733 34.1033 252.231 20.867C224.729 7.63071 194.395 0.687382 163.486 0.553197C132.577 0.419009 101.886 7.09743 73.6964 20.0919C45.5067 33.0864 20.5427 52.0628 0.660332 75.6102L41.0953 107.946C55.8751 90.4413 74.4323 76.335 95.3875 66.6754C116.343 57.0158 139.157 52.0513 162.134 52.1511C185.11 52.2508 207.659 57.4122 228.103 67.2515C248.547 77.0909 266.361 91.3551 280.22 108.984C294.079 126.612 303.626 147.152 308.153 169.075C312.679 190.999 312.068 213.742 306.365 235.615C300.662 257.487 290.014 277.927 275.212 295.413C260.41 312.899 214.967 359.366 194 369L228.103 369L275.212 369Z",
    fill: "#D9D9D9",
    fillOpacity: 0.35
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse37);
export default __webpack_public_path__ + "static/media/ellipse-37.b36c45fc99c650bacb9e38882ad3a6eb.svg";
export { ForwardRef as ReactComponent };